import React, { useState, useEffect } from "react";
import Grid from '@mui/material/Grid';
import FormSelect from '../Form/FormSelect';
import FormTextField from '../Form/FormTextField';
import Subtitle from "../Shared/Subtitle";
import options from "../Config/options";

const JobSchedule = props => {
    const [cron, setCron] = useState(props.schedule || 'cron(0 0 * * ? *)')
    const [frequency, setFrequency] = useState('daily')
    const [time, setTime] = useState("00:00")
    const [inputProps, setInputProps] = useState({});

    useEffect(() => {
        if (props.schedule) {
            setCron(props.schedule)

            let [mi, hr, dom, mo, dow, yy] = props.schedule.replace(/[cron()]/g, '').split(' ')
            let newFrequency = frequency

            if (newFrequency === "custom") {
                setTime("00:00")
            } else {
                if (hr === "0/1") {
                    newFrequency = "hourly"
                    hr = 0 
                } else if (hr === '12-0') {
                    newFrequency = "12hrmf"
                    hr = 12
                } else {
                    newFrequency = "daily"
                }
                const hh = localHr(newFrequency, hr);
                setTime(`${hh.toString().padStart(2, '0')}:${mi.padStart(2, '0')}`)
            }
            setFrequency(newFrequency)
        }
    }, [props.schedule])


    const localHr = (freq, hr) => {
        const date = new Date();
        date.setUTCHours(hr)
        const newHr = date.getHours()

        const frozen = options.frequency.find(x => x.value === freq)?.frozen
        frozen ? setInputProps({
            min: `${newHr.toString().padStart(2, '0')}:00`,
            max: `${newHr.toString().padStart(2, '0')}:59`,
        }) : setInputProps({});

        return newHr
    }

    const handleChange = e => {
        const node = e.target.name
        let newFrequency = frequency
        let newTime = time
        let newCron = cron
        let [mi, hr, dom, mo, dow, yy] = newCron.replace(/[cron()]/g, '').split(' ')

        const date = new Date();
        date.setUTCHours(hr)
        let hh = date.getHours()

        if (node === "Frequency") {
            newFrequency = e.target.value
            setFrequency(newFrequency)
        } else if (node === "Time") {
            [hh, mi] = e.target.value.split(':').map(x => parseInt(x) || 0)
            if (newFrequency === "daily") {
                date.setHours(hh)
                hr = date.getUTCHours().toString()
            }
        } else if (node === "Cron") {
            newCron = e.target.value
        }

        // apply frequency factors
        switch (newFrequency) {
            case 'hourly':
                [hr, dom, dow] = ["0/1", "*", "?"];
                hh = localHr(newFrequency, 0);
                break;
            case '12hrmf':
                [hr, dom, dow] = ["12-0", "?", "MON-FRI"];
                hh = localHr(newFrequency, 12);
                break;
            case 'daily':
                [dom, dow] = ["*", "?"];
                hr = parseInt(hr.split("-")[0]) || 0;
                hh = localHr(newFrequency, hr);
                break;
            default:
                [hh, mi] = [0, 0]
                break;
        }
        // set newCron if not custom
        if (newFrequency !== "custom") {
            newCron = `cron(${mi} ${hr} ${dom} ${mo} ${dow} ${yy})`
        }

        props.handler({ target: { name: "Schedule", value: newCron } })
    }


    return (
        <Grid container className="Container">
            <Subtitle
                type="Schedule"
            />
            <Grid item xs={6}>
                <FormSelect
                    name='Frequency'
                    label='Frequency'
                    value={frequency || ""}
                    disabled={props.disabled}
                    options={options.frequency}
                    handler={handleChange}
                />
                {frequency === "custom" &&
                <FormTextField
                    name="Cron"
                    value={cron || ""}
                    disabled={props.disabled}
                    handler={handleChange}
                />
                }
            </Grid>
            <Grid item xs={6} sx={{ mt: 0.125, pr: 1 }}>
                <FormTextField
                    name="Time"
                    type="time"
                    label='Start Time'
                    value={time || "00:00"}
                    disabled={props.disabled || frequency === "custom"}
                    handler={handleChange}
                    inputProps={{
                        inputProps: {
                            step: 300, // 5 min
                            ...inputProps
                        }
                    }}

                />
            </Grid>
        </Grid>
    )
}
export default JobSchedule;